import React from "react";

export default function ToggleSwitch({
    enabled,
    setEnabled,
    label,
    onColor = "bg-theme_clr2 bg-opacity-70 border-[1.5px] border-theme_clr2",
    offColor = "bg-gray-300",
    size = "md",
    className = "",
}) {
    const sizes = {
        sm: { w: "w-8", h: "h-4", circle: "h-3 w-3", move: "translate-x-4" },
        md: { w: "w-12", h: "h-[26px]", circle: "h-5 w-5", move: "translate-x-[22px]" },
        lg: { w: "w-14", h: "h-8", circle: "h-6 w-6", move: "translate-x-7" },
    };

    const s = sizes[size];

    return (
        <div className={`flex items-center gap-3 ${className}`}>
            {label && <span className="text-gray-700 font-medium">{label}</span>}
            <button draggable={false} onDragStart={(e) => e.stopPropagation()} onClick={(e) => {
                e.stopPropagation();
                setEnabled(!enabled)
                }} className={`relative inline-flex ${s.h} ${s.w} items-center rounded-full transition-colors duration-300 ${enabled ? onColor : offColor}`}>
                <span className={`inline-block ${s.circle} transform bg-white rounded-full shadow transition-transform duration-300 ${enabled ? s.move : "translate-x-1"}`}></span>
            </button>
        </div>
    );
}

// How to Use Switch
{/*  
    const [switchStatus, setSwitchStatus] = useState(true);
    const [notifications, setNotifications] = useState(false);
    <div className="p-6 space-y-6 bg-white rounded-2xl shadow">
        <ToggleSwitch
            label="Future Save Status"
            enabled={status}
            setEnabled={setStatus}
            size="md"
        />

        <ToggleSwitch
            label="Enable Notifications"
            enabled={notifications}
            setEnabled={setNotifications}
            onColor="bg-green-500"
            size="lg"
        />
    </div> 
*/}
